const guiColors = {
    'motion-primary': '#FF0EB0',
    'motion-primary-transparent': '#FF0EB0e6',
    'motion-tertiary': '#DB1C9C',

    'looks-secondary': '#FF0EB0',
    'looks-secondary-light': '#FF5CCA',
    'looks-secondary-lighter': '#FF8FDA',
    'looks-transparent': '#FF0EB059',
    'looks-light-transparent': '#e675c026',
    'looks-secondary-dark': '#CF0087',
    'looks-secondary-darker': '#AD006A',
    'looks-secondary-deep-dark': '#800042',
	
	'data-primary': '#8d00ff',

    'extensions-primary': '#8d00ff',
    'extensions-tertiary': '#7200d0',
    'extensions-transparent': '#8d00ff35',
    'extensions-light': '#a63aff',

    'drop-highlight': '#FF0EB0',
	
	'menu-bar-background-image': 'linear-gradient(to right, #FF0EB0 0%, #8d00ff 100%)',
    'menu-bar-background-image-dark': 'linear-gradient(to right, #CF0087 0%, #5D00C2 100%)'
};


export {
    guiColors,
};